<template>
<form autocomplete="off">
  <div class="md-autocomplete-loading" v-show="isPromisePending">
    <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
  </div>

  <!-- Save button -->
  <CrudToolbar 
    :save="saveFunc? saveFunc : save" 
    :form="form" 
    :$v="$v" 
    :formConfig="formConfig" 
    :cancel="cancel" 
    :atShowAuditLog="formConfig.atShowAuditLog" 
    :atOpenMergeDialog="formConfig.atOpenMergeDialog" 
    :mergeText='formConfig.mergeText'
    :btnActive="btnActive" 
    :isSaveInProgress="isSaveInProgress"
  ></CrudToolbar>

  <div class="md-layout">

    <!-- Output a list of required fields on form -->
    <div v-if="$v && $v.form && showRequirements" class="requirementsNotice">
      <h4>The following fields require attention:</h4>
      <template v-for="(slot, slotName, index) in formConfig.slots">
        <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">
          <template v-if="$v.form[name] && $v.form[name].$invalid">
          <p :key="`${name}-${index}`" :data-target="name" @click="scrollToField(name)" class="required-field-label">
            <span class="fa-stack fa-sm">
              <i class="far fa-circle fa-stack-2x text-danger"></i>
              <i class="fas fa-times fa-stack-1x text-danger"></i>
              <!-- <i class="far fa-circle fa-stack-2x text-success"></i>
              <i class="fas fa-check fa-stack-1x text-success"></i> -->
            </span>
            {{field.label}}
          </p>
          </template>
        </template>
      </template>
    </div>

    <!-- ATLAS-1600: <Service> Show Premier indicator at Service level if Account is Premier -->
    <div v-if="isShowBadge" class="__badge-div">
      <md-badge class="md-square __badge" md-content="Premier"/>
    </div>
    <grid-layout
      :layout.sync="formLayout"
      :col-num="12"
      :is-draggable="false"
      :is-resizable="false"
      :auto-size="false"
      :is-mirrored="false"
      :vertical-compact="true"
      :responsive="false"
      :margin="[10, 10]"
      :use-css-transforms="true"
    >

      <grid-item v-for="(slot, slotName, index) in formConfig.slots" :id="slotName" v-show="slotHasVisibleFields(slotName)"
                 :x="slot.layout.x"
                 :y="slot.layout.y"
                 :w="slot.layout.w"
                 :h="slot.layout.h"
                 :i="slot.layout.i"
                 :key="'griditem_'+ slotName + slot.layout.i"
      >

        <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content md-layout-item md-xsmall-size-100 md-size-50 md-medium-size-50 md-large-size-25">
          <h3><span class="heading">{{slot.label}}</span></h3>Create a base record to enable this section.
        </div>
        
        <div v-else :key="slotName" class="vue-grid-item-content">
            <h3 v-if="slot.label" :id="slot.id"><span class="heading">{{slot.label}}</span></h3>        
          <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">

            <CrudCheckbox
              v-if="field.type == 'checkbox'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>

            <CrudSearchModal
              v-else-if="field.type == 'searchmodal'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData" :filter="field.filter ? field.filter : filter"></CrudSearchModal>

            <CrudSearchModalParentChild
              v-else-if="field.type == 'parentchild'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData" :filter="filter"></CrudSearchModalParentChild>

            <CrudDatepicker
              v-else-if="field.type == 'datepicker'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

            <CrudSelect
              v-else-if="field.type == 'select'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

            <CrudAutocomplete
              v-else-if="field.type == 'autocomplete'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

            <CrudJson
              v-else-if="field.type == 'json'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

            <CrudSwitch
              v-else-if="field.type == 'switch'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>


            <!--
            <CrudText
              v-else :key="name"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.formConfig.fields" :field.sync="field"></CrudText>
              -->
            <CrudId
              v-else-if="field.type == 'id'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

            <!-- ATLAS-532: Add Notes Field - Richtext editor -->
            <CrudTextEditor
              v-else-if="field.type == 'textEditor'" :key="name" :name="name" class="field"
              :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"
            ></CrudTextEditor>

            <CrudText
              v-else :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>
          </template>
          <gridItemHook />
        </div>
      </grid-item>
    </grid-layout>

  </div>
  <div v-show="scrollActive">
    <CrudToolbar 
      :save="save" 
      :form="form" 
      :$v="$v" 
      :formConfig="formConfig" 
      :cancel="cancel" 
      :isSaveInProgress="isSaveInProgress"
    ></CrudToolbar>
  </div>
</form>
</template>

<script>
  import RecordForm from '@/mixins/RecordForm';
  import VueGridLayout from 'vue-grid-layout';
  // import ResizeSensor from '@/assets/js/ResizeSensor';
  // import ResizeSensor from 'css-element-queries';

  const gridItemHook = {
    mounted(){
      // [i] This pushes each gridItem into this.gridItems below for config-form
      this.$parent.$parent.$parent.gridItems.push(this.$parent);
    },
    render(h){
      return h('div', [h('div',{attrs: {contentEditable: true, class: 'editable'}})])
    }
  };

  export default {
    name: "config-form",
    mixins: [RecordForm],
    props: {
      saveFunc: {
        type: Function,
      },
    },
    components: {
      GridLayout: VueGridLayout.GridLayout,
      GridItem: VueGridLayout.GridItem,
      gridItemHook
    },
    computed: {
      showRequirements() {
        let result = false;
       if (this.formConfig && this.formConfig.pageMode === 'new' && this.$v.form.$invalid && !this.$route.params.id) {
          result = true;
        }
        if(this.formConfig.pageMode === 'edit'){
          if(this.recordData && this.recordData.id && this.$v.form.$invalid){
            result = true;
          }
        }
        return result;
      },
    },
    methods: {
      slotHasVisibleFields(slotName) {
        const fields = this.formConfig.fields;
        let result = false;
        let slotFields = Object.filter(fields, ([name, field]) => field.slot == slotName); 

        for (var field in slotFields) {
          if (slotFields.hasOwnProperty(field)) {
            let target = slotFields[field];
            if (typeof target.hide == 'undefined') {
                result = true;
                break;
            } else if (typeof target.hide == "function") {
              let hideResult = target.hide();
              if (!hideResult) {
                result = true;
                break;
              }
            }
          }
        }
        return result;
      },
      handleScroll() {
        this.scrollActive = true;
      },
      /**
       * ATLAS-1750: <Global><CRUD> Unsatisfied requirements - scroll to field
       */
      scrollToField(target){
        const selector = `.vue-grid-item-content [name="${target}"]`;
        const eleTarget = document.querySelector(selector);
        if (eleTarget) {
          const eleParent = eleTarget.closest('.field')
          if(eleParent) {
            eleParent.scrollIntoView({
              behavior:"smooth"
            });
          } else {
            eleTarget.scrollIntoView({
              behavior:"smooth"
            });
          }
        }
      }
    },
    data () {
      return {
        formLayout: [//default value so that at least it works
          {"x":0,"y":0,"w":2,"h":2,"i":"0"},
          {"x":2,"y":0,"w":2,"h":4,"i":"1"},
          {"x":4,"y":0,"w":2,"h":5,"i":"2"},
          {"x":6,"y":0,"w":2,"h":3,"i":"3"},
          {"x":8,"y":0,"w":2,"h":3,"i":"4"},
          {"x":10,"y":0,"w":2,"h":3,"i":"5"},
          {"x":0,"y":5,"w":2,"h":5,"i":"6"},
          {"x":2,"y":5,"w":2,"h":5,"i":"7"},
          {"x":4,"y":5,"w":2,"h":5,"i":"8"},
          {"x":6,"y":4,"w":2,"h":4,"i":"9"},
          {"x":8,"y":4,"w":2,"h":4,"i":"10"},
          {"x":10,"y":4,"w":2,"h":4,"i":"11"},
          {"x":0,"y":10,"w":2,"h":5,"i":"12"},
          {"x":2,"y":10,"w":2,"h":5,"i":"13"},
          {"x":4,"y":8,"w":2,"h":4,"i":"14"},
          {"x":6,"y":8,"w":2,"h":4,"i":"15"},
          {"x":8,"y":10,"w":2,"h":5,"i":"16"},
          {"x":10,"y":4,"w":2,"h":2,"i":"17"},
          {"x":0,"y":9,"w":2,"h":3,"i":"18"},
          {"x":2,"y":6,"w":2,"h":2,"i":"19"}
        ],
        gridItems: [],
        scrollActive: false
      }
    },
    beforeMount() {
      let layout = [];
      this.$loopo(this.formConfig.slots, (slot) => {
        layout.push(slot.layout);
      });
      if (layout.length) {
        this.formLayout = layout;
      }
    },
    updated() {
      this.gridItems.forEach(gridItem => {
        gridItem.autoSize();
      });
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);

      // Reset the toolbar (form controls and tab navigation)
      let topPageToolbar = window.document.getElementById("topPageToolbar");
      if (topPageToolbar) {
        topPageToolbar.innerHTML = '';
      }

      let mainPanelWindow = window.document.getElementById('mainPanelWindow');
      if (mainPanelWindow && topPageToolbar) {
                
        let tabContent = mainPanelWindow.querySelector(".md-tabs.topNavTabs .md-tabs-content .md-tabs-container .md-tab");
        if (tabContent) {
          let toolbar = tabContent.getElementsByClassName("md-toolbar")[0];
          if (toolbar) {
            let controls = toolbar.getElementsByTagName('ul')[0];
            if (controls && controls.parentElement.id !== 'topPageToolbar') {
              if (controls.id !== "movedFormControls" && !window.document.getElementById("movedFormControls")) {
                controls.id = "movedFormControls";
                topPageToolbar.append(controls);
              } else {
                controls.remove();
              }
              
              toolbar.remove();
            }
          }  
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  };
</script>

<style lang="scss">
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {

    .md-toolbar.md-transparent {
      background-color: #FFF !important;
    }

    &.md-warning {
      // background-color: #e57373;

      .md-toolbar.md-transparent {
        background-color: #FFF !important;
      }

    }

    .form-field-view {
        overflow-wrap: break-word;
    }
    
    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    .vue-grid-item-content {
      display: flex;
      flex-wrap: wrap;
      background-color: #FFF;
      padding-left: 0;
    }

    .field {
      width: 50%;
      float: left;
      padding-right: 30px;
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

 .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }

  /* for Premier badge on Service details */
  .__badge-div {
    padding: 5px 0;
    margin: 4px 0 10px;
  }
  .md-badge.md-square.__badge.md-theme-default.md-position-top.md-square.__badge {
    left: 0px;
    background: #FFD700;
    color: #000000;
    margin: 5px 3px 0px 4px;
    border-radius: 4px;
    width: 40px;
    font-weight: 500;
    position: relative;
  }

  .requirementsNotice {
    background-color: lightyellow;
    border: 1px solid black;
    border-radius: 5px;
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;

    h4 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: bold;
    }
    p {
      margin-bottom: 0;
      margin-top: 5px;
    }
    .fa-stack.fa-sm {
      font-size: 10px;
    }
    .required-field-label {
      color: #2196f3;
      cursor: pointer;
    }
  }
</style>
